import { property } from 'lit/decorators.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const ButtonElementMixin = (superClass) => {
  class ButtonElement extends superClass {
    constructor() {
      super(...arguments);
      this.type = "button";
    }
    /**
     * Handle the root click event.
     */
    handleButtonClick() {
      if (this.type === "submit") {
        this.closest("FORM")?.dispatchEvent(new SubmitEvent("submit", { cancelable: true, submitter: this }));
      }
    }
  }
  __decorateClass([
    property()
  ], ButtonElement.prototype, "type");
  return ButtonElement;
};

export { ButtonElementMixin };
